import { Injectable } from '@angular/core';
import Project from '../../../interfaces/project';
import { BehaviorSubject } from 'rxjs';
import { Apollo } from 'apollo-angular';
import { queries } from './graphql/deal-search';

@Injectable({
  providedIn: 'root',
})
export class DealSearchService {
  private _options: Project[] = [];
  private options = new BehaviorSubject<Project[]>(this._options);
  public options$ = this.options.asObservable();

  private _loading = false;
  private loading = new BehaviorSubject(this._loading);
  public loading$ = this.loading.asObservable();
  constructor(private apollo: Apollo) {}

  private setLoading(loading: boolean) {
    this._loading = loading;
    this.loading.next(this._loading);
  }
  private setOptions(options: Project[]) {
    this._options = options;
    this.options.next(options);
  }
  public clearOptions() {
    this.setOptions([]);
  }
  searchForDeal(search: string | null) {
    if (search?.length) {
      this.setLoading(true);
      let sub = this.apollo
        .query({
          query: queries.SEARCH_FOR_DEAL,
          variables: { search, searchLike: `%${search}%` },
        })
        .subscribe(({ data }) => {
          this.setLoading(false);
          if (data?.search_projects.data) {
            this.setOptions(data.search_projects.data);
            sub?.unsubscribe();
          }
        });
    } else {
      this.setOptions([]);
    }
  }
}
